import *
    as TYPES_USER
    from "@/views/users/store/types.js";

//import * as TYPES_PROVIDERS from "@/views/suppliers/store/types/types.js";

const _pathUri = new PathUri(config.port, config.context, "/afiliados/");
const _pathUriCommom = new PathUri(configCommom.port, configCommom.context);

import config from "@/views/users/config/user_api.js";
import configCommom from "@/plugins/commom/config/commom_api.js";
import PathUri from "@/utils/path_uri";
import axios from "@/plugins/http/axios.js";
import Swal from "sweetalert2";

import { initialState } from "./state.js";

const actions = {
    [TYPES_USER.ACTION_LIST_USERS]: ({ state, commit }, idEmpresa) => {
        return new Promise((resolve, reject) => {
            state.loading = true;
            axios({
                method: "get",
                url: `${config.baseUrl + _pathUri.generateUri() + "emp/" + idEmpresa}`,
            })
                .then((resp) => {
                    const users = resp.data.map((e, i) => ({
                        ...e,
                        activeDialogUser: false,
                        index: i,
                    }));
                    commit(TYPES_USER.SET_USERS, users);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                })
                .finally(() => (state.loading = false));
        });
    },
    [TYPES_USER.ACTION_DIALOG_ACTIVE]: ({ commit }, data) => {
        commit(TYPES_USER.SET_DIALOG_ACTIVE, data);
    },

    [TYPES_USER.ACTION_DETAIL_USER]: ({ state, commit, dispatch }, data) => {
        new Promise((resolve, reject) => {
            state.loading = true;
            try {
                // es un usuario con informacion para actualizar
                if (data.idAfiliado) {
                    dispatch(TYPES_USER.ACTION_GET_DETAIL_USER, data)
                        .then((resp) => {
                            const detailUser = resp.data;
                            commit(TYPES_USER.SET_DETAIL_USER, detailUser);
                            commit(TYPES_USER.SET_EPS, detailUser.administradoras[0]);
                            commit(TYPES_USER.SET_AFP, detailUser.administradoras[1]);
                            commit(TYPES_USER.SET_ARL, detailUser.administradoras[2]);
                            commit(TYPES_USER.SET_CCF, detailUser.administradoras[3]);
                            commit(TYPES_USER.SET_USER_DETAIL_FIELDS, { path: "idAfiliado", value: data.idAfiliado });
                            resolve();
                        })
                        .catch((err) => {
                            reject(err);
                        });
                } else {
                    // es agregar un nuevo usuaro
                    commit(TYPES_USER.SET_DETAIL_USER, { ...initialState.user });
                    commit(TYPES_USER.SET_USER_DETAIL_FIELDS, { path: "tipoIdentificacion", value: state.typesIdentification[0]["idIdentificacion"] });
                    resolve();
                }
            } catch (error) {
                reject(error);
            }
            state.loading = false;
        });
    },
    [TYPES_USER.ACTION_GET_DETAIL_USER]: (_, payload) => {
        const { idEmpresa, idAfiliado } = payload;
        return new Promise((resolve, reject) => {
            axios.get(`${config.baseUrl + _pathUri.generateUri() + "emp/" + idEmpresa + "/afiliado/" + idAfiliado}`)
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [TYPES_USER.ACTION_INITIAL_DETAIL_USER]: async ({ dispatch }, payload) => {
        await dispatch(TYPES_USER.ACTION_LIST_TYPES_IDENTIFICATION);
        await dispatch(TYPES_USER.ACTION_LIST_CIVIL_STATUS);
        await dispatch(TYPES_USER.ACTION_LIST_GENDERS);
        await dispatch(TYPES_USER.ACTION_LIST_TYPES_EPS);
        await dispatch(TYPES_USER.ACTION_LIST_TYPES_AFP);
        await dispatch(TYPES_USER.ACTION_LIST_TYPES_ARL);
        await dispatch(TYPES_USER.ACTION_LIST_TYPES_CCF);
        await dispatch(TYPES_USER.ACTION_DETAIL_USER, payload);
    },

    [TYPES_USER.ACTION_CREATE_USER]: ({ dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`${config.baseUrl + _pathUri.generateUri() + "crear"}`, payload)
                .then((resp) => {
                    dispatch(TYPES_USER.ACTION_LIST_USERS, payload.idEmpresa);
                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "El funcionario fue creado exitosamente",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [TYPES_USER.ACTION_UPDATE_USER]: ({ state, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            state.loading = true;
            axios.post(`${config.baseUrl + _pathUri.generateUri() + "actualizar"}`, payload)
                .then((resp) => {
                    dispatch(TYPES_USER.ACTION_LIST_USERS, payload.idEmpresa);
                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "El funcionario fue modificado exitosamente",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                })
                .finally(() => (state.loading = false));
        });
    },
    [TYPES_USER.ACTION_LIST_TYPES_IDENTIFICATION]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.get(`${configCommom.baseUrl + _pathUriCommom.generateUri() + "/identificacion/tipoid"}`)
                .then((resp) => {
                    const typesIdentification = resp.data;
                    commit(TYPES_USER.SET_TYPES_IDENTIFICATION, typesIdentification);
                    resolve(resp.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [TYPES_USER.ACTION_LIST_GENDERS]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.get(`${configCommom.baseUrl + _pathUriCommom.generateUri() + "/generos/"}`)
                .then((resp) => {
                    const genders = resp.data;
                    commit(TYPES_USER.SET_GENDERS, genders);
                    resolve(resp.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [TYPES_USER.ACTION_LIST_CIVIL_STATUS]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.get(`${configCommom.baseUrl + _pathUriCommom.generateUri() + "/estadocivil/"}`)
                .then((resp) => {
                    const civilStatus = resp.data;
                    commit(TYPES_USER.SET_CIVIL_STATUS, civilStatus);
                    resolve(resp.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    [TYPES_USER.ACTION_LIST_TYPES_EPS]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.get(`${configCommom.baseUrl + _pathUriCommom.generateUri() + "/administradoras/salud"}`)
                .then((resp) => {
                    const typesEps = resp.data;
                    commit(TYPES_USER.SET_TYPES_EPS, typesEps);
                    resolve(resp.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    [TYPES_USER.ACTION_LIST_TYPES_AFP]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.get(`${configCommom.baseUrl + _pathUriCommom.generateUri() + "/administradoras/pension"}`)
                .then((resp) => {
                    const typesAfp = resp.data;
                    commit(TYPES_USER.SET_TYPES_AFP, typesAfp);
                    resolve(resp.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    [TYPES_USER.ACTION_LIST_TYPES_ARL]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.get(`${configCommom.baseUrl + _pathUriCommom.generateUri() + "/administradoras/riesgos"}`)
                .then((resp) => {
                    const typesArl = resp.data;
                    commit(TYPES_USER.SET_TYPES_ARL, typesArl);
                    resolve(resp.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    [TYPES_USER.ACTION_LIST_TYPES_CCF]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios.get(`${configCommom.baseUrl + _pathUriCommom.generateUri() + "/administradoras/caja"}`)
                .then((resp) => {
                    const typesCcf = resp.data;
                    commit(TYPES_USER.SET_TYPES_CCF, typesCcf);
                    resolve(resp.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    /*[TYPES_USER.ACTION_CALL_LIST_COMPANY_PROVIDERS]: async ({ dispatch, commit }, payload) => {
        const proveedores = await dispatch(`${TYPES_PROVIDERS.PROVIDERS_M}${TYPES_PROVIDERS.ACTION_LIST_COMPANY_PROVIDERS}`, payload);
        commit(TYPES_USER.SET_USER_PRODUCT_DETAIL_FIELDS, { path: "proveedores", value: proveedores });
    },*/
    [TYPES_USER.ACTION_INITIAL_USER_PRODUCT_DETAIL]: async ({ state, dispatch }, payload) => {
        state.loading = true;
        Promise.all([dispatch(TYPES_USER.ACTION_CALL_LIST_COMPANY_PROVIDERS, payload)])
            .finally(() => state.loading = false);
    },

    [TYPES_USER.ACTION_LIST_TYPES_BENEFITS]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: `${configCommom.baseUrl + _pathUriCommom.generateUri() + "/estadocivil/"}`,
            })
                .then((resp) => {
                    const civilStatus = resp.data;
                    commit(TYPES_USER.SET_CIVIL_STATUS, civilStatus);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [TYPES_USER.ACTION_LIST_PRODUCTS]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: `${configCommom.baseUrl + _pathUriCommom.generateUri() + "/estadocivil/"}`,
            })
                .then((resp) => {
                    const civilStatus = resp.data;
                    commit(TYPES_USER.SET_CIVIL_STATUS, civilStatus);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [TYPES_USER.ACTION_LIST_TYPES_PRODUCTS]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: `${configCommom.baseUrl + _pathUriCommom.generateUri() + "/estadocivil/"}`,
            })
                .then((resp) => {
                    const civilStatus = resp.data;
                    commit(TYPES_USER.SET_CIVIL_STATUS, civilStatus);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [TYPES_USER.ACTION_LIST_TYPES_CONTRACTS]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: `${configCommom.baseUrl + _pathUriCommom.generateUri() + "/estadocivil/"}`,
            })
                .then((resp) => {
                    const civilStatus = resp.data;
                    commit(TYPES_USER.SET_CIVIL_STATUS, civilStatus);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

export default actions;